import { combineSearchParams } from "lib/combine-search-params"

/**
 * Fetch from the application server
 * @param {string} url - the URL to fetch
 * @param {object} options - the fetch options to use
 * @returns {Promise<Response>}
 */
export function getServerUrl(path) {
    const protocol = window.appProtocol || process.env.REACT_APP_PROTOCOL
    const host = window.appServerLocation || process.env.REACT_APP_SERVER
    return `${protocol}://${host}${path}`
}

export function server(url, options) {
    options ??= {}
    options.credentials = "include"
    const token = getAccessToken()
    if (token && !hasAuthorizationHeader(options.headers)) {
        options.headers = { ...options.headers, Authorization: `Bearer ${token}` }
    }
    if (!url.startsWith("http")) {
        if (url.startsWith("/")) url = url.slice(1)
        url = `${window.appProtocol || process.env.REACT_APP_PROTOCOL}://${
            window.appServerLocation || process.env.REACT_APP_SERVER
        }/${url}`
    }
    return fetch(combineSearchParams(url), options)
}

function getAccessToken() {
    try {
        const token = localStorage.getItem("sfg20AccessToken")
        return token && token !== "undefined" ? token : null
    } catch (e) {
        return null
    }
}

function hasAuthorizationHeader(headers) {
    if (!headers) return false
    return Object.keys(headers).some((key) => key.toLowerCase() === "authorization")
}
